import { render, staticRenderFns } from "./enquiry-message.vue?vue&type=template&id=3e271fe2&scoped=true&"
import script from "./enquiry-message.vue?vue&type=script&lang=js&"
export * from "./enquiry-message.vue?vue&type=script&lang=js&"
import style0 from "./enquiry-message.vue?vue&type=style&index=0&id=3e271fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e271fe2",
  null
  
)

export default component.exports